import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { TextFade } from '@/shared/components/fade-text';
import { TextGradient } from '@/shared/components/text-gradient';
export const Main = () => {
  return <Article tag="main" className="relative 2xl:h-[calc(100vh-100px)]">
      <div className="flex flex-col place-items-center">
        <TextGradient text="Кейсы учеников" tag="h1" className="mb-4 text-center text-4xl xss:text-5xl sm:mb-6 sm:text-6xl md:text-7xl lg:text-8xl" />

        <TextFade text="Узнайте как английский помогает нашим ученикам достигать своих целей" tag="p" className="max-w-lg text-center text-muted-foreground lg:text-lg lg:leading-7" />
      </div>

      <GradientBg className="hidden sm:block" type="circle" origin="center" size={400} />
    </Article>;
};